/**
 * Deterministic avatar colour + monogram for chat collaborators.
 * Same seed → same visual on every client. Pure Inter monogram + palette,
 * no external avatar service.
 */

const PALETTE = [
    "#0A0A0A", "#2563EB", "#16A34A", "#7C3AED", "#DC2626",
    "#EA580C", "#0891B2", "#DB2777", "#4F46E5", "#059669",
];

function hash(str) {
    let h = 0;
    for (let i = 0; i < (str || "").length; i++) {
        h = (h * 31 + str.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
}

export function avatarColor(seed) {
    return PALETTE[hash(seed || "anon") % PALETTE.length];
}

export function avatarInitials(name) {
    const n = (name || "").trim();
    if (!n) return "?";
    const parts = n.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
